import validate from '@/validation/validate';
import {debounce} from "lodash-es";

// Autocomplete werte nach WCAG2.1
const AutocompleteValues = ["name","honorific-prefix","given-name","additional-name","family-name","honorific-suffix","nickname","organization-title","username","new-password","current-password","organization","street-address","address-line1","address-line2","address-line3","address-level4","address-level3","address-level2","address-level1","country","country-name","postal-code","cc-name","cc-given-name","cc-additional-name","cc-family-name","cc-number","cc-exp","cc-exp-month","cc-exp-year","cc-csc","cc-type","transaction-currency","transaction-amount","language","bday","bday-day","bday-month","bday-year","sex","url","photo","tel","tel-country-code","tel-national","tel-area-code","tel-local","tel-local-prefix","tel-local-suffix","tel-extension","email","impp"];

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    id: {
      type: String,
      required: false,
    },
    validation: {
      type: [String, Function],
      required: false,
    },
    customErrorMessage: {
      type: [String, Object],
      required: false,
    },
    defaultValue: {
      type: null, // any value is allowed,
      required: false,
      default: null,
    },
    autocomplete: {
      type: String,
      required: false,
      validator: value => {
        const valid = AutocompleteValues.includes(value)
        if (!valid) {
          console.log('Autocomplete value must be valid', value);
        }

        return valid;
      },
    }
  },
  computed: {
    filteredName() {
      let r = this.name;
      ['lieferadresse_'].forEach(prefix => {
        r = r.replaceAll(prefix, '');
      })
      return r;
    },
    attributes() {
      const attributes = this.$attrs;
      if (this.autocomplete) {
        attributes.autocomplete = this.autocomplete;
      }
      return attributes;
    },
    identifier() {
      return this.id ? this.id : this.name;
    },
    isRequired() {
      return typeof this.validation === 'string' && /required[,:\W]?/g.test(this.validation);
    },
    requiredAsterisk() {
      return this.isRequired ? '*' : '';
    },
    errorMessages() {
      if (typeof this.customErrorMessage === 'string')
        return this.customErrorMessage;

      // Wenn customErrorMessage ein object
      if (typeof this.customErrorMessage === 'object') {
        return Object.keys(this.failedRules)
          .map(rule => this.customErrorMessage[rule] || this.failedRules[rule])
          .join('<br />')
        ;
      }

      return Object.values(this.failedRules).join('<br />');
    },
    htmlLabel() {
      const lastClosingParagraph = /<\/p>$/;
      if (!this.isRequired) return this.label;
      if (lastClosingParagraph.test(this.label)) {
        return this.label.replace(lastClosingParagraph, ' ' + this.requiredAsterisk);
      }
      return this.label + '' + this.requiredAsterisk;
    },
    identifierError() {
      return this.identifier + '-error';
    }
  },
  created() {
    this.findParentForm();
    if (this.form) {
      this.form.registerField(this.name, this);
      this.fieldValue = this.form.getValue(this.name);

      if (!this.fieldValue && this.defaultValue !== null) {
        console.log('setting default value for field ', this.name)
        this.form.setValue(this.name, this.defaultValue);
      }
    }
  },
  beforeDestroy() {
    this.form.deregisterField(this.name, this);
  },
  data: () => ({
    form: null,
    fieldValue: null,
    failedRules: {},
    valid: true,
  }),
  methods: {
    setValue(value) {
      this.fieldValue = value;
      if (this.valid === false) {
        this.validate({formData: this.form.collectFormData()});
      }
      this.emitChanged(this.fieldValue);
    },
    updateValue(value) {
      this.form.setValue(this.name, value);
    },
    findParentForm() {
      let parent = this.$parent;
      while (parent && !this.form) {
        if (typeof parent.registerField === 'function') {
          this.form = parent
        } else {
          parent = parent.$parent;
        }
      }
      if (!parent) {
        console.error('could not find parent form element for form input ', this.name)
      }
    },
    validate(context) {
      const validationResult = validate(this.validation, context, this.fieldValue);
      this.valid = validationResult.valid;
      this.failedRules = validationResult.failedRules;
      return validationResult.valid;
    },
    emitChanged: debounce(function(value) {
      this.$emit('changed', value);
    }, 300),
  }
}
